import apolloClient from '../../utils/apollo-client';
import { getModels } from '../graphql/car-search';

export default async function getModelsByMakeBodyType(params) {
  const { make, body, yearLimits, newOnly } = params;
  const response = await apolloClient().then((client) =>
    client.query({
      query: getModels,
      variables: { makeId: make, bodyId: body, yearLimits, newOnly }
    })
  );

  return response.data.models;
}
